

import React from 'react';
import { Typography, Box, List, ListItem, ListItemButton, ListItemContent } from '@mui/joy';
import { Link as RouterLink } from 'react-router-dom';

const ClientProjectList = () => {
  const dummyProjects = [
    { id: 1, name: 'Springfield Site Development' },
    { id: 2, name: 'Downtown Mixed-Use Project' },
    { id: 3, name: 'Coastal Redevelopment Phase 2' },
  ];

  return (
    <Box>
      <Typography level="h4" gutterBottom>
        Your Projects
      </Typography>
      <List>
        {dummyProjects.map((project) => (
          <ListItem key={project.id}>
            <ListItemButton component={RouterLink} to={`/client/project/${project.id}`}>
              <ListItemContent>{project.name}</ListItemContent>
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );
};

export default ClientProjectList;